"use client";

import { getProviders, signIn } from "next-auth/react";
import { useEffect, useState, Suspense } from "react";
import { useSearchParams } from "next/navigation";
import { getProviderIcon, getProviderName } from "~/lib/icons";

function SignInButtons() {
  const [providers, setProviders] =
    useState<Awaited<ReturnType<typeof getProviders>>>(null);
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") ?? "/";

  useEffect(() => {
    const fetchProviders = async () => {
      const providers = await getProviders();
      setProviders(providers);
    };
    void fetchProviders();
  }, []);

  return (
    <div className="flex w-full flex-col gap-3">
      {providers &&
        Object.values(providers).map((provider) => (
          <button
            key={provider.id}
            type="button"
            className="k-nav-pill flex w-full items-center justify-center gap-3 !border-[var(--fg-dim)] px-4 py-3 hover:!border-[var(--fg-muted)]"
            onClick={() => void signIn(provider.id, { callbackUrl })}
          >
            {getProviderIcon(provider.id)}
            Sign in with {getProviderName(provider.id)}
          </button>
        ))}
    </div>
  );
}

export default function SignIn() {
  return (
    <div className="flex min-h-screen w-screen items-center justify-center bg-[var(--bg)] px-6 py-16">
      <div className="flex w-full max-w-sm flex-col items-center gap-16">
        <div
          className="text-4xl tracking-[0.18em] text-[var(--fg)]"
          style={{ fontFamily: "var(--font-display)", fontWeight: 500 }}
        >
          KOLLMANN
        </div>

        <div className="flex w-full flex-col items-center gap-8">
          <div className="flex flex-col items-center gap-3 text-center">
            <h1
              className="text-3xl text-[var(--fg)]"
              style={{ fontFamily: "var(--font-display)", fontWeight: 500 }}
            >
              Sign in
            </h1>
            <p
              className="text-[11px] uppercase tracking-[0.18em] text-[var(--fg-muted)]"
              style={{ fontFamily: "var(--font-mono)" }}
            >
              Continue to your workspace
            </p>
          </div>

          <div className="h-px w-full bg-[var(--hairline)]" />

          <Suspense fallback={null}>
            <SignInButtons />
          </Suspense>
        </div>
      </div>
    </div>
  );
}
